import React, { useState } from "react";
import styles from "./StaffViewReciepe.module.css";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import OverviewComponent from "./StaffOverview/StaffOverview";
import IngredientsMaterial from "./StaffIngredients&Material/StaffI&M";
import RecipeComponent from "./StaffRecipeDetails/StaffRecipeDetails";
import OrderHistoryComponent from "./StaffOrderHistory/StaffOrderHistory";


const StaffViewReciepe = () => {
  const navigate = useNavigate();
  const options1 = [
    { id: 1, name: "Overview" },
    { id: 2, name: "Ingredients & Material" },
    { id: 3, name: "Recipe" },
    { id: 4, name: "Order History" },
  ];
  const [focusedTab1, setFocusedTab1] = useState(options1[0]);

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"French Batard Sliced"}
        showBackIcon={true}
  
      >
        <TopTabComponent
          options={options1}
          focused={focusedTab1}
          setFocused={setFocusedTab1}
          TopTabListStyle={styles.TopTabListStyle}
        />
      </HeaderComponent>

      {focusedTab1?.name === options1[0].name ? (
        <OverviewComponent />
      ) : focusedTab1?.name === options1[1].name ? (
        <IngredientsMaterial />
      ) : focusedTab1?.name === options1[2].name ? (
        <RecipeComponent />
      ) : focusedTab1?.name === options1[3].name ? (
        <OrderHistoryComponent />
      ) : null}
    </div>
  );
};

export default StaffViewReciepe;
